import React from 'react';
import {
  Badge,
  Breadcrumb,
  Button,
  Dropdown,
  Space,
  Typography,
} from 'antd';
import {
  ArrowLeftOutlined,
  MoreOutlined,
  ReloadOutlined,
  ApiOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

type Props = {
  marketplace: string;
  connected: boolean;
  lastSyncLabel?: string | null;
  checking?: boolean;
  syncing?: boolean;
  onCheck: () => void;
  onSync: () => void;
  onOpenAccess?: () => void;
};

export const IntegrationHeader = ({
  marketplace,
  connected,
  lastSyncLabel,
  checking,
  syncing,
  onCheck,
  onSync,
  onOpenAccess,
}: Props) => {
  return (
    <div style={{ marginBottom: 16 }}>
      <Breadcrumb
        style={{ marginBottom: 8 }}
        items={[
          {
            title: (
              <Link to="/settings/auth_marketplace">
                <ArrowLeftOutlined /> Интеграции
              </Link>
            ),
          },
          { title: marketplace },
        ]}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
          alignItems: 'flex-start',
        }}
      >
        <div>
          <Title level={3} style={{ margin: 0 }}>
            {marketplace}
          </Title>
          <Space wrap size={[8, 4]} style={{ marginTop: 6 }}>
            <Badge
              status={connected ? 'success' : 'warning'}
              text={connected ? 'Подключено' : 'Требует настройки'}
            />
            {lastSyncLabel ? (
              <Text type="secondary">· Последняя синхронизация: {lastSyncLabel}</Text>
            ) : null}
          </Space>
        </div>
        <Space wrap>
          <Button
            icon={<ApiOutlined />}
            loading={checking}
            onClick={onCheck}
          >
            Проверить подключение
          </Button>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            loading={syncing}
            onClick={onSync}
          >
            Синхронизировать
          </Button>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'access',
                  label: 'Настройки доступа',
                  onClick: onOpenAccess,
                },
              ],
            }}
            trigger={['click']}
          >
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        </Space>
      </div>
    </div>
  );
};
